import React from "react";
import styles from "./brokers.module.css"

const Brokers = ({ children, title, onSuccessBroker, state, setState }) => {

    const handleChangeTieneBroker = (e) => {
        let isValue = e.target.value === 'true' ? true : false
        setState((state) => {
            return {
                ...state,
                broker: isValue,
                codigoBroker: null,
                codigoOk: false,
                validacionCodigo: false,
                intermediarioRequest: {
                    codigoIntermediario: null,
                    codigoAgencia: null,
                    codigoOficina: null,
                    codigoModalidad: null
                },
                validacionNoBroker: false
            }
        })
    }

    return (
        <div className={`${styles['w3-modal']} ${styles['show-modal-beneficiaries']}`}>
            <div className={styles['w3-modal-content']}>
                <div className={styles['w3-header']}></div>
                <div className={styles['w3-container']}>
                    <p className={styles['w3title']}>
                        {title}
                    </p>
                    <div className={styles['pregunta']}>¿Desea seleccionar un broker?</div>
                    <div className={styles['optionlight']}>
                        <div style={{ textAlign: "center", paddingLeft: "20px" }}>
                            <label>
                                <input
                                    type='radio'
                                    value={true}
                                    checked={state.broker === true}
                                    selected={state.broker === true}
                                    onChange={handleChangeTieneBroker}
                                />
                                <span className={styles['spanRadio']}>Si</span>
                            </label>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label>
                                <input
                                    type='radio'
                                    value={false}
                                    checked={state.broker === false}
                                    selected={state.broker === false}
                                    onChange={handleChangeTieneBroker}
                                />
                                <span className={styles['spanRadio']}>No</span>
                            </label>
                        </div>
                    </div>
                    {children}
                    {(state.broker !== null && !state.broker) ||
                        (state.broker !== null && state.broker && state.codigoOk) ?
                        <div className={styles['w3areabtn']}>
                            <button
                                type='button'
                                className={styles['btn-pago-accion']}
                                onClick={onSuccessBroker}
                            >
                                Continuar
                            </button>
                        </div>
                        : null
                    }
                </div>
            </div>
        </div>
    )
}

export default Brokers